<template lang="pug">
	div(
		v-if="datos"
		@click="verEntrada($event, datos.evento)",
		:title="$moment(datos.evento.fechaIni).format('HH:mm') + ' ' + datos.evento.usuarioNombre + ' - ' + datos.evento.clienteNombre",
		:style="estiloSup"
		draggable="true"
		v-on:dragstart="test"
		:id="datos.evento.ID_entrada"
		)
		div(:style="estilo")
			b.mr-2 {{datos.evento.fechaIni | moment('HH:mm')}} - {{datos.evento.fechaFin | moment('HH:mm')}}
			| {{datos.evento.usuarioNombre}} - 
			span(v-if="datos.evento.gestion === 0") {{datos.evento.clienteNombre}} 
			span(v-else) Gestión interna
				br
				b {{datos.evento.comentarios_previos}}
			div.barras.bottom(@mousedown="captura($event)", @mouseup="libera($event)", @click="stopProp")
				span.fa.fa-bars
</template>

<script>
import axios from 'axios'
export default {
	props: ['evento', 'alto'],
	data () {
		return {
			datos: null,
			offset: {
				bottom: 0,
				top: 0
			},
			resized: {
				top: 0,
				bottom: 0
			},
			arrastrando: false,
			listener: null
		}
	},
	watch: {
		evento: function (nuevo) {
			window.setTimeout(() => {
				console.log('Arrastrando antes: ' + this.arrastrando)
				console.log('Reiniciando datos')
				this.datos = nuevo
				this.offset = {
					bottom: 0,
					top: 0
				}
				this.resized = {
					top: 0,
					bottom: 0
				}
				this.arrastrando = false
				this.listener = null
			}, 300)
		}
	},
	created () {
		this.datos = JSON.parse(JSON.stringify(this.evento))
	},
	computed: {
		estilo () {
			if (!this.datos) {
				return {}
			}

			const e = {
				position: 'absolute',
				display: 'block',
				top: (0 + this.resized.top) + 'px',
				left: 0,
				right: 0,
				bottom: (0 - this.resized.bottom) + 'px',
				backgroundColor: (this.datos.evento.gestion === 1) ? '#fff716' : this.datos.estilo.bgColor,
				color: (this.datos.evento.gestion === 1) ? '#000000' : this.datos.estilo.color,
				overflow: 'hidden'
			}
			return e
		},

		estiloSup () {
			return {}
		}
	},
	methods: {
		inicioArrastre (ev) {
			ev.preventDefault()
			ev.stopPropagation()
		},
		test (ev) {
			ev.stopPropagation()
			ev.dataTransfer.setData('text/plain', JSON.stringify(this.datos))
		},
		verEntrada (ev, evento) {
			console.log('Arrastrando es: ' + this.arrastrando)
			if (this.arrastrando) {
				ev.stopPropagation()
				ev.preventDefault()
				return
			}
			this.$emit('ver', evento)
		},

		captura (ev) {
			ev.stopPropagation()
			ev.preventDefault()
			let elem = ev.srcElement

			this.arrastrando = true

			while (elem.className !== 'eventoCalendario') {
				elem = elem.parentElement
			}
			this.offset.bottom = ev.clientY - (ev.clientY % 20)
			window.addEventListener('mousemove', this.mueveRatonBottom)
			window.addEventListener('click', this.libera)
			window.addEventListener('mouseup', this.libera)
		},

		libera (ev, zona) {
			ev.stopPropagation()
			ev.preventDefault()

			window.removeEventListener('click', this.libera)
			window.removeEventListener('mouseup', this.libera)
			window.removeEventListener('mousemove', this.mueveRatonBottom)

			const total = Math.floor(this.resized.bottom / 20)
			const minutos = total * 15
			const datos = {
				ID_entrada: this.datos.evento.ID_entrada,
				minutos: minutos
			}
			axios.post('/agenda-comercial/php/api/set-fecha-incremento-evento.php', datos)
				.then(() => {
					this.$emit('actualizar')
					this.offset.top = this.resized.top + 0
					this.offset.bottom = this.resized.bottom + 0
					this.resized = {
						top: 0,
						bottom: 0
					}
				})
				.catch(e => {
					this.$store.commit('toast/danger', {
						titulo: 'Error',
						mensaje: e.response.data.error
					})
				})
		},

		stopProp (ev) {
			ev.stopPropagation()
			ev.preventDefault()
		},

		mueveRatonTop (ev) {
			const inc = ev.clientY - (ev.clientY % 20.5)
			this.resized.top = inc - this.offset.top
		},

		mueveRatonBottom (ev) {
			// Calculamos cuanto porcentaje es 30 minutos
			const porcion = 20
			const inc = ev.clientY - (ev.clientY % porcion)
			this.resized.bottom = inc - this.offset.bottom
		}
	}
}
</script>


<style>
	.barras {
		position: absolute;
		left: 0;
		right: 0;
		text-align: center;
		color: white;
		display: none;
	}

	.capaEventosDia > div > div > .barras.bottom {
		bottom: 0;
		cursor: s-resize;
	}

	.capaEventosDia > div > div > .barras.top {
		top: 0;
		cursor: n-resize;
	}

	.capaEventosDia > div > div:hover > .barras {
		display: block;
	}
</style>



// WEBPACK FOOTER //
// src/modulos/agenda-comercial/vue/componentes/calendario/evento.vue